import React, { useState } from 'react';
import App from '../App';

interface AppContextProps {
  lang?: string;
  setLang?: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
}

export const AppContext = React.createContext<AppContextProps>({});

export const AppProvider = () => {
  const [lang, setLang] = useState<string>();

  return (
    <AppContext.Provider value={{ lang, setLang }}>
      <App />
    </AppContext.Provider>
  );
};
